class MobileHeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.headerTopEl = document.querySelector('.header__top');
    this.isMainMenu = this.classList.contains('mobile-header-main-menu');
    this.links = this.querySelectorAll('a.header__mobile-menu-link');

    this.toggleButton = document.querySelector('.header__menu-icon');
    this.backButtons = this.querySelectorAll('.header__submenu-back');

    this.openSubmenuButtons = this.querySelectorAll('button.header__mobile-menu-link[data-open-submenu-index]');

    this.registerListeners();
  }

  registerListeners() {
    this.links.forEach((link) => {
      link.addEventListener('click', () => {
        this.toggle();
      });
    });
    this.openSubmenuButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const submenuIndex = button.dataset.openSubmenuIndex;
        const targetMenu = document.querySelector(`mobile-header-menu[data-menu-index="${submenuIndex}"]`);
        if (targetMenu) {
          targetMenu.toggle();
        }
      });
    });

    if (this.isMainMenu && this.toggleButton) {
      this.toggleButton.addEventListener('click', () => {
        document.querySelectorAll("mobile-header-menu[data-state='show']").forEach((menu) => {
          menu.toggle();
        });
        this.toggle();
      });
    }

    this.backButtons.forEach((backButton) => {
      backButton.addEventListener('click', () => {
        this.toggle();
      });
    });
  }

  toggle() {
    const currentState = this.dataset.state;

    if (currentState === 'transition') {
      return;
    }

    const newState = currentState === 'show' ? 'hide' : 'show';
    this.dataset.state = 'transition';

    if (this.isMainMenu) {
      const newStateHeaderTop = newState === 'show' ? 'open' : 'initial';
      this.headerTopEl.dataset.state = newStateHeaderTop;

      if (newState === 'show') {
        document.querySelector('body').classList.add('avoid-scroll');
      } else {
        document.querySelector('body').classList.remove('avoid-scroll');
      }
    }

    if (newState === 'hide') {
      setTimeout(() => {
        this.dataset.state = newState;
      }, 500);
    } else {
      setTimeout(() => {
        this.dataset.state = newState;
      }, 10);
    }
  }
}

customElements.define('mobile-header-menu', MobileHeaderMenu);

class DesktopHeaderMenuItem extends HTMLElement {
  constructor() {
    super();

    this.submenu = this.querySelector('.header__desktop-submenu');

    if (!this.submenu) {
      return;
    }

    this.addEventListener('mouseover', () => {
      this.setAttribute('data-state', 'open');
    });

    this.addEventListener('mouseout', (e) => {
      this.setAttribute('data-state', 'hide');
      console.log(e);
    });
  }
}

customElements.define('desktop-header-menu-item', DesktopHeaderMenuItem);

class VariantCard extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.dataset.variantId;
    this.variantButtons = this.querySelectorAll('.variant-card-variant-button');
    this.productCard = this.closest('.product-card');
    this.registerListeners();
  }

  registerListeners() {
    if (this.variantButtons.length > 1) {
      this.variantButtons.forEach((variantButton) => {
        variantButton.addEventListener('click', () => {
          const variantId = variantButton.dataset.variantId;
          const newVariantCard = this.productCard.querySelector(`variant-card[data-variant-id="${variantId}"]`);
          this.setAttribute('data-show', false);
          newVariantCard.setAttribute('data-show', true);
        });
      });
    }
  }
}
customElements.define('variant-card', VariantCard);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class LocalizationSwitcher extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('.localization-switcher__close');
    this.closeButton.addEventListener('click', () => {
      this.toggle();
    });
  }
  toggle() {
    const currentState = this.dataset.active === 'true';
    const newState = !currentState;
    this.setAttribute('data-active', !currentState);

    if (newState) {
      document.querySelector('body').classList.add('avoid-scroll');
    } else {
      // If mobile navbar is open, do not remove avoid-scroll class
      if (document.querySelector("mobile-header-menu[data-state='show']")) {
        return;
      }
      document.querySelector('body').classList.remove('avoid-scroll');
    }
  }
}

function toggleLocalizationSwitcher() {
  document.querySelector('localization-switcher').toggle();
}

customElements.define('localization-switcher', LocalizationSwitcher);

class CustomHeader extends HTMLElement {
  constructor() {
    super();

    this.lastScrollTop = 0;
    this.scrollThreshold = 5; // Minimum scroll distance to trigger change

    // Bind the scroll handler
    this.handleScroll = debounce(this.handleScroll.bind(this), 10);

    // Add scroll listener
    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    // Only apply on desktop (you can adjust the breakpoint as needed)
    if (window.innerWidth < 990) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollDifference = scrollTop - this.lastScrollTop;

    // Only trigger if scroll distance exceeds threshold
    if (Math.abs(scrollDifference) < this.scrollThreshold) return;

    if (scrollTop > this.lastScrollTop && scrollTop > 450) {
      this.setAttribute('data-desktop-show', 'false');
      // Scrolling down and not at the very top
    } else {
      // Scrolling up or at the top
      this.setAttribute('data-desktop-show', 'true');
    }

    if (scrollTop > 500) {
      this.setAttribute('data-desktop-background', 'default');
    } else {
      this.setAttribute('data-desktop-background', 'transparent');
    }

    // Update last scroll position
    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  disconnectedCallback() {
    // Clean up scroll listener when element is removed
    window.removeEventListener('scroll', this.handleScroll);
  }
}

customElements.define('custom-header', CustomHeader);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    // Get data attributes
    this.accountProfileUrl = this.dataset.accountProfileUrl;
    this.currentReferralCode = this.dataset.currentReferralCode;
    this.userLoggedIn = this.dataset.userLoggedIn === 'true';
    this.loginUrl = this.dataset.loginUrl;
    this.enabledCountries = this.dataset.enabledCountries
      ? this.dataset.enabledCountries
          .split(',')
          .map((c) => c.trim().toUpperCase())
          .filter(Boolean)
      : [];
    this.limitedCountries = this.dataset.limitedCountries
      ? this.dataset.limitedCountries
          .split(',')
          .map((c) => c.trim().toUpperCase())
          .filter(Boolean)
      : [];
    this.locale = this.dataset.locale || 'en';

    // Make the element clickable
    this.style.cursor = 'pointer';
    this.setAttribute('role', 'button');
    this.setAttribute('tabindex', '0');

    // Bind methods
    this.handleClick = this.handleClick.bind(this);
    this.handleTriggerClick = this.handleTriggerClick.bind(this);

    this.registerListeners();
    this.registerTriggerElements();
    this.observeNewTriggerElements();
  }

  registerListeners() {
    // Handle click
    this.addEventListener('click', this.handleClick);

    // Handle keyboard activation (Enter or Space)
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.handleClick();
      }
    });
  }

  registerTriggerElements() {
    // Find all elements with data-trigger-account-icon attribute
    const triggerElements = document.querySelectorAll('[data-trigger-account-icon]');

    triggerElements.forEach((element) => {
      this.setupTriggerElement(element);
    });
  }

  observeNewTriggerElements() {
    // Create a MutationObserver to watch for dynamically added elements
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          // Check if the added node is an element with the trigger attribute
          if (node.nodeType === 1) {
            // Element node
            if (node.hasAttribute && node.hasAttribute('data-trigger-account-icon')) {
              this.setupTriggerElement(node);
            }
            // Also check child elements
            if (node.querySelectorAll) {
              const triggerElements = node.querySelectorAll('[data-trigger-account-icon]');
              triggerElements.forEach((element) => this.setupTriggerElement(element));
            }
          }
        });
      });
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Store observer reference for cleanup if needed
    this.mutationObserver = observer;
  }

  setupTriggerElement(element) {
    // Avoid duplicate event listeners
    if (element.hasAttribute('data-account-icon-initialized')) {
      return;
    }

    element.setAttribute('data-account-icon-initialized', 'true');

    // Make trigger elements clickable
    element.style.cursor = 'pointer';

    // Handle click
    element.addEventListener('click', this.handleTriggerClick);

    // Handle keyboard activation if not already a button/link
    if (!['BUTTON', 'A'].includes(element.tagName)) {
      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');

      element.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleTriggerClick(e);
        }
      });
    }
  }

  handleTriggerClick(e) {
    // Prevent default action if it's a link or button
    e.preventDefault();
    e.stopPropagation();

    // Call the same logic as clicking on the account icon
    this.handleClick();
  }

  async handleClick() {
    const { action, countryCode, isEU } = await this.resolveGeoAction();
    switch (action) {
      case 'waitlist':
        return this.redirectToWaitlist();
      case 'popup':
        return this.showRegionPopup(isEU, countryCode);
      default:
        return this.navigate();
    }
  }

  async resolveGeoAction() {
    if (this.enabledCountries.length === 0 && this.limitedCountries.length === 0) {
      return { action: 'navigate' };
    }

    const countryCode = await this.detectCountry();
    return AccountIcon.classifyCountry(countryCode, this.enabledCountries, this.limitedCountries);
  }

  detectCountry() {
    if (!this.countryPromise) {
      this.countryPromise = fetch(
        window.location.origin +
          '/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true&currency[enabled]=true',
      )
        .then((r) => r.json())
        .then((data) => data?.detected_values?.country?.handle?.toUpperCase() || null)
        .catch(() => {
          this.countryPromise = null;
          return null;
        });
    }
    return this.countryPromise;
  }

  static classifyCountry(countryCode, enabledCountries, limitedCountries) {
    if (!countryCode) return { action: 'navigate' };
    if (limitedCountries.includes(countryCode)) return { action: 'waitlist', countryCode };
    if (enabledCountries.length > 0 && !enabledCountries.includes(countryCode)) {
      return { action: 'popup', countryCode, isEU: AccountIcon.EU_COUNTRIES.includes(countryCode) };
    }
    return { action: 'navigate', countryCode };
  }

  redirectToWaitlist() {
    const lang = (this.locale || 'en').split('-')[0].toLowerCase();
    const waitlistPages = { de: '/pages/waitlist-de', nl: '/pages/waitlist-nl' };
    window.location.href = waitlistPages[lang] || '/pages/waitlist-en';
  }

  navigate() {
    if (this.userLoggedIn && this.currentReferralCode && this.currentReferralCode.trim() !== '') {
      window.location.href = this.accountProfileUrl;
    } else {
      window.location.href = this.loginUrl;
    }
  }

  showRegionPopup(isEU, countryCode) {
    document.querySelector('region-check-popup')?.show(this, isEU, countryCode);
  }

  // Update data attributes if needed (useful for dynamic updates)
  updateReferralCode(newCode) {
    this.currentReferralCode = newCode;
    this.dataset.currentReferralCode = newCode;
  }

  updateLoginStatus(isLoggedIn) {
    this.userLoggedIn = isLoggedIn;
    this.dataset.userLoggedIn = isLoggedIn ? 'true' : 'false';
  }

  disconnectedCallback() {
    // Clean up mutation observer when element is removed
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }
}

AccountIcon.EU_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
];

customElements.define('account-icon', AccountIcon);

class RegionCheckPopup extends HTMLElement {
  connectedCallback() {
    this.emailInput = this.querySelector('custom-form-input input');
    this.waitlistSection = this.querySelector('.region-check-popup__waitlist-section');
    this.euActions = this.querySelector('.region-check-popup__actions--eu');
    this.nonEuActions = this.querySelector('.region-check-popup__actions--non-eu');
    this.klaviyoApiKey = this.dataset.klaviyoApiKey;
    this.klaviyoListId = this.dataset.klaviyoListId;

    this.closeBtn = this.querySelector('.region-check-popup__close');
    this.closeBtn?.addEventListener('click', () => this.close());
    this.querySelectorAll('[data-action="cancel"], [data-action="close"]').forEach((el) =>
      el.addEventListener('click', () => this.close()),
    );
    this.querySelector('[data-action="save"]')?.addEventListener('click', () => this.handleSave());
    this.querySelector('[data-action="retry"]')?.addEventListener('click', () => {
      this.dataset.state = 'initial';
    });
    this.addEventListener('click', (e) => {
      if (e.target === this) this.close();
    });

    this.trapFocus = this.trapFocus.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
  }

  show(trigger, isEU, countryCode) {
    window.scrollTo(0, 0);
    this.dataset.state = 'initial';
    this.trigger = trigger;
    this.countryCode = countryCode || null;
    this.isEU = isEU === true;

    const showWaitlist = isEU === true;
    if (this.closeBtn) this.closeBtn.hidden = showWaitlist;
    if (this.waitlistSection) this.waitlistSection.hidden = !showWaitlist;
    if (this.euActions) this.euActions.hidden = !showWaitlist;
    if (this.nonEuActions) this.nonEuActions.hidden = showWaitlist;

    this.hidden = false;
    document.body.style.overflow = 'hidden';
    (showWaitlist ? this.emailInput : this.querySelector('[data-action="close"]'))?.focus();
    document.addEventListener('keydown', this.trapFocus);
    document.addEventListener('keydown', this.handleEscape);
  }

  close() {
    document.removeEventListener('keydown', this.trapFocus);
    document.removeEventListener('keydown', this.handleEscape);
    this.hidden = true;
    document.body.style.overflow = '';
    this.reset();
    this.trigger?.focus();
    this.trigger = null;
  }

  reset() {
    this.dataset.state = 'initial';
    if (this.emailInput) this.emailInput.value = '';
  }

  async handleSave() {
    if (!this.emailInput?.value || !this.emailInput.validity.valid) {
      this.emailInput?.focus();
      return;
    }

    let success = true;

    if (this.klaviyoApiKey && this.klaviyoListId) {
      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.klaviyoApiKey}`, {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            revision: '2026-01-15',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: this.emailInput.value,
                      ...(this.countryCode && {
                        location: { country: this.countryCode },
                      }),
                      properties: {
                        source: 'region_check_popup',
                        is_eu: this.isEU,
                        ...(this.countryCode && { detected_country: this.countryCode }),
                      },
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: this.klaviyoListId,
                  },
                },
              },
            },
          }),
        });
        success = response.ok;
      } catch (e) {
        success = false;
      }
    }

    this.dataset.state = success ? 'success' : 'error';

    if (success) {
      setTimeout(() => this.close(), 3000);
    }
  }

  trapFocus(e) {
    if (e.key !== 'Tab') return;
    const focusable = Array.from(
      this.querySelectorAll(
        'a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])',
      ),
    ).filter((el) => !el.closest('[hidden]'));
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  handleEscape(e) {
    if (e.key === 'Escape') this.close();
  }
}

customElements.define('region-check-popup', RegionCheckPopup);

class CustomFormInput extends HTMLElement {
  constructor() {
    super();

    this.errorElement = this.querySelector('.input-error');
    this.errorSpan = this.errorElement ? this.errorElement.querySelector('span') : null;
    this.inputElement = this.querySelector('input');

    // Initialize state
    this.dataset.state = this.dataset.state || 'initial';
  }

  showError(message) {
    if (this.errorSpan && message) {
      this.errorSpan.textContent = message;
    }
    this.dataset.state = 'error';
  }

  hideError() {
    this.dataset.state = 'initial';
    if (this.errorSpan) {
      this.errorSpan.textContent = '';
    }
  }

  // Method to get the current error state
  hasError() {
    return this.dataset.state === 'error';
  }

  // Method to get the input value
  getValue() {
    return this.inputElement ? this.inputElement.value : '';
  }

  // Method to set the input value
  setValue(value) {
    if (this.inputElement) {
      this.inputElement.value = value;
    }
  }

  // Method to focus the input
  focus() {
    if (this.inputElement) {
      this.inputElement.focus();
    }
  }
}

customElements.define('custom-form-input', CustomFormInput);
